/* eslint-disable import/no-cycle */
import React from 'react';
import BOMImportSteps from './BOMImportSteps';

const BOMImport = ({ detailPageName }: { detailPageName: string }) => {
  return <BOMImportSteps detailPageName={detailPageName} prefills={{}} />;
};

export default BOMImport;
